<template>
    <Modal title="添加学生作品" v-model="visible">
      <Form ref="userVideoForm" class="form" :model="userVideoParams" :rules="userVideoRules" :label-width="80">
        <Row>
          <Col :span="22">
            <Form-item label="作品名称" prop="title">
              <Input v-model="userVideoParams.title"></Input>
            </Form-item>
          </Col>
        </Row>
        <Row>
          <Col :span="12">
            <Form-item label="学生ID" prop="uid">
              <Input v-model.number="userVideoParams.uid"></Input>
            </Form-item>
          </Col>
          <Col :span="12">
            <Form-item label="分组" prop="ageGroup">
              <Select v-model.number="userVideoParams.ageGroup">
                <Option v-for="item in $constant.userVideoType" :key="item.code" :value="item.code">
                  {{item.text}}
                </Option>
              </Select>
            </Form-item>
          </Col>
        </Row>
        <Row>
          <Col :span="22">
            <Form-item label="学生作品" prop="videoUrl">
              <el-upload
                class="upload-demo"
                :action="$appConfig.baseUrl + '/upload/fileUpload'"
                :on-change="videoChange"
                :on-success="videoSuccess"
                :headers="headers"
                :on-progress="handleProgress"
                :before-upload="beforeUpload"
                accept="video/*"
                :limit="2"
                multiple
                :file-list="videoFileList">
                <el-button size="small"><i class="el-icon-upload el-icon--left"></i>上传</el-button>
              </el-upload>
            </Form-item>
          </Col>
        </Row>
        <Row>
          <Col :span="22">
            <Form-item label="作品封面" prop="videoPicUrl">
              <el-upload
                class="upload-demo"
                :action="$appConfig.baseUrl + '/upload/fileUpload'"
                :on-change="videoPicChange"
                :on-success="videoPicSuccess"
                :headers="headers"
                :on-progress="handleProgress"
                :before-upload="beforeUpload"
                accept="image/*"
                :limit="2"
                multiple
                :file-list="videoPicFileList">
                <el-button size="small"><i class="el-icon-upload el-icon--left"></i>上传</el-button>
              </el-upload>
            </Form-item>
          </Col>
        </Row>
        <Row>
          <Col :span="22">
            <Form-item label="抖音链接" prop="douyinUrl">
              <Input v-model="userVideoParams.douyinUrl" placeholder="抖音分享链接或文案"/>
            </Form-item>
          </Col>
        </Row>
        <Row>
          <Col :span="22">
            <Form-item label="小红书链接" prop="xhsUrl">
              <Input v-model="userVideoParams.xhsUrl" placeholder="小红书分享链接或文案"/>
            </Form-item>
          </Col>
        </Row>
        <Row>
          <Col :span="22">
            <Form-item label="视频号链接" prop="channelsUrl">
              <Input v-model="userVideoParams.channelsUrl" placeholder="视频号分享链接或文案"/>
            </Form-item>
          </Col>
        </Row>
      </Form>
      <div slot="footer">
        <Button type="text" size="large" @click="visible=false">取消</Button>
        <Button type="primary" size="large" :loading="loadingAddModal" @click="addUserVideo">提交</Button>
      </div>
    </Modal>
</template>

<script>
  export default {
    name: 'AddUserVideoModal',
    props: {
      value: {
        type: Boolean,
        default: false
      },
      successCallback: {
        type: Function
      }
    },
    data () {
      return {
        visible: this.value,
        userVideoParams: {
          uid: null,
          title: '',
          videoUrl: '',
          videoPicUrl: '',
          douyinUrl: '',
          xhsUrl: '',
          channelsUrl: '',
          ageGroup: null
        },
        userVideoRules: {
          title: [
            { type: 'string', required: true, message: '请填写作品名称', trigger: 'blur' }
          ],
          uid: [
            { type: 'integer', required: true, message: '请填写学生ID', trigger: 'blur' }
          ],
          ageGroup: [
            { type: 'integer', required: true, message: '请选择类型', trigger: 'blur' }
          ]
        },
        headers: {},
        videoFileList: [],
        videoPicFileList: [],
        videoUrl: '',
        videoPicUrl: '',
        loadingAddModal: false,
      }
    },
    methods: {
      videoChange (file, fileList) {
        this.videoFileList = fileList.slice(-1)
      },
      videoSuccess (res, file, fileList) {
        this.userVideoParams.videoUrl = res.data.name
        this.videoUrl = res.data.url
      },
      videoPicChange (file, fileList) {
        this.videoPicFileList = fileList.slice(-1)
      },
      videoPicSuccess (res, file, fileList) {
        this.userVideoParams.videoPicUrl = res.data.name
        this.videoPicUrl = res.data.url
      },
      beforeUpload (file) {
        this.headers.token = this.$store.get('token')
        if (this.$store.get('account') && this.$store.get('password')) {
          this.headers.account = this.$store.get('account')
          this.headers.password = this.$store.get('password')
        }
        this.$Message.loading('服务器正在处理中...', 0)
        return true
      },
      handleProgress (event, file, fileList) {
        if (event.percent === 100) {
          event.percent = 99
        }
      },
      svUrlError () {
        let p = this.userVideoParams
        let hostIn = function (host, domain) {
          return host === domain || host.slice(-domain.length - 1) === '.' + domain
        }
        let rules = [
          { key: 'douyinUrl', name: '抖音', ok: (host) => ['douyin.com', 'v.douyin.com', 'iesdouyin.com'].some(d => hostIn(host, d)) },
          { key: 'xhsUrl', name: '小红书', ok: (host) => ['xiaohongshu.com', 'xhslink.com', 'xhslink.cn'].some(d => hostIn(host, d)) },
          { key: 'channelsUrl', name: '视频号', ok: (host, path) => hostIn(host, 'channels.weixin.qq.com') || (hostIn(host, 'weixin.qq.com') && path.indexOf('sph') >= 0) }
        ]
        for (let i = 0; i < rules.length; i++) {
          let r = rules[i]
          let text = (p[r.key] || '').trim()
          if (!text) continue
          if (text.length > 1024) return r.name + '链接过长'
          let m = /https?:\/\/([^/?#\s:]+)(?::\d+)?([^?#\s]*)/i.exec(text)
          if (!m || !r.ok(m[1].toLowerCase(), m[2] || '')) return r.name + '链接不是' + r.name + '地址'
        }
        return ''
      },
      addUserVideo () {
        let self = this
        self.loadingAddModal = true
        self.$refs.userVideoForm.validate((valid) => {
          if (!valid) {
            self.$Message.warning('信息输入错误!')
            self.loadingAddModal = false
            return
          }
          let video = (self.userVideoParams.videoUrl || '').trim()
          let p = self.userVideoParams
          let link = ((p.douyinUrl || '') + (p.xhsUrl || '') + (p.channelsUrl || '')).trim()
          if (!video && !link) {
            self.$Message.warning('请上传学生作品或填写短视频链接')
            self.loadingAddModal = false
            return
          }
          let urlError = self.svUrlError()
          if (urlError) {
            self.$Message.warning(urlError)
            self.loadingAddModal = false
            return
          }
          self.$http.post('/userVideo/insert', self.userVideoParams).then(function (res) {
            if (res && res.data > 0) {
              self.visible = false
              self.$Message.success('提交成功!')
              self.successCallback()
              self.loadingAddModal = false
            } else {
              self.$Message.error(res.msg)
            }
          }).catch(function (e) {
            self.visible = false
            self.loadingAddModal = false
          })
        })
      }
    },
    watch: {
      value (val) {
        this.visible = val
      },
      visible (val) {
        if (val === false) {
          this.userVideoParams = {}
          this.viceoFileList = []
          this.videoPicFileList = []
          this.$emit('on-close', false)
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// AddUserVideoModal.vue?b906b3c0